//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Swiper from 'swiper';

import { WHEEL_MULTIPLIERS } from '../wheel.entity';
// 假设的倍率映射函数（替代 Angular 的 wheelMultiplierRatio pipe）
function getMultiplierRatio(winColor) {
  return WHEEL_MULTIPLIERS[winColor] || '2x';
}

export default {
  name: 'WheelHomeHistoryGames',
  props: {
    games: {
      type: Array,
      default: () => []
    },
    streamerMode: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      swiper: null,
      swiperInitialized: false
    };
  },
  watch: {
    games() {
      this.$nextTick(() => {
        this.initSwiper();
      });
    }
  },
  mounted() {
    this.initSwiper();
  },
  beforeDestroy() {
    if (this.swiper) {
      this.swiper.destroy(true, true);
    }
  },
  computed:{
    currencyType() {
      return Number(this.$route.meta?.currencyType ?? this.$route.query.currencyType ?? 0);
    },
		wheelHistoryRouteName() {
			if (this.currencyType === 1) return 'happyCoinWheelHistory';
			if (this.currencyType === 2) return 'coin1WheelHistory';
			return 'wheelHistory';
		},
  },
  methods: {
    getMultiplierRatio(winColor) {
      return getMultiplierRatio(winColor);
    },

    getTooltipText(winColor) {
      const ratio = getMultiplierRatio(winColor);
      if (this.streamerMode) {
        return ratio.replace(/x/gi, '');
      }
      return ratio;
    },

    initSwiper() {
      const el = this.$refs.swiperEl;

      if (el && !this.swiperInitialized && el.querySelector('.swiper-slide')) {
        this.swiperInitialized = true;
        this.swiper = new Swiper(el, {
          slidesPerView: 15,
          spaceBetween: 6.4 // 0.4rem * 16 (换算为 16px 基准下的 px)
        });
      }
    }
  }
};
